var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[[_c('navbar',{staticClass:"navbar"}),_vm._v(" "),_c('mobile-navbar',{staticClass:"mobile-navbar"})],_vm._v(" "),_c('nuxt',{staticClass:"main-content"}),_vm._v(" "),_c('my-footer',{staticClass:"my-footer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }